import { ReactElement } from "react";
import Title from "@components/Title";
import DocumentEmbed from "@components/DocumentEmbed";
import document from "@assets/documents/terms-and-conditions.pdf";
import styles from "./TermsAndConditions.module.scss";

const TermsAndConditions = (): ReactElement => (
  <div className={styles.container}>
    <Title text={"Terms & Conditions"} tag="h3" fixedWidth line />
    <DocumentEmbed document={document} />
  </div>
);

export default TermsAndConditions;
